/* eslint-disable */
import * as Types from '../../../../../../generated/graphql'

import { gql } from '@apollo/client'
import { MyTravelAtlasFragmentDoc } from '../../../ProfileCountryVisited/__generated__/ProfileCountryVisited'
import { MyTeamoTestFragmentDoc } from '../../../Profile/gql/__generated__/Teamo'
export type GQLCurrentUserFragment = {
  __typename?: 'Query'
  my?: {
    __typename?: 'My'
    interests: {
      __typename?: 'MyInterests'
      interestsCount: number
      interests: {
        __typename?: 'MyInterestsConnection'
        nodes: Array<{
          __typename?: 'MyInterest'
          interestId: number
          text: string
        }>
        pageInfo: {
          __typename?: 'PageInfo'
          hasNextPage: boolean
          endCursor: any
        }
      }
    }
    travelAtlas: {
      __typename?: 'MyTravelAtlas'
      visitedCountries: {
        __typename?: 'MyTravelAtlasVisitedCountries'
        visitedCountriesCount: number
        visitedCountries: {
          __typename?: 'MyTravelAtlasVisitedCountriesConnection'
          nodes: Array<{
            __typename?: 'MyTravelAtlasVisitedCountry'
            visible: boolean
            country: {
              __typename?: 'Country'
              id: string
              code: string
              isoCode: string
              name: string
            }
          }>
        }
      }
    }
    teamo?: {
      __typename?: 'MyTeamo'
      surveyResults?: Array<{
        __typename?: 'TeamoPeculiarity'
        id: number
        points: number
        title: string
        description: string
      }> | null
    } | null
  }
}

export const CurrentUserFragmentDoc = gql`
  fragment CurrentUser on Query {
    my @include(if: $authorized) {
      ...MyTravelAtlas
      interests {
        interestsCount
        interests(limit: $limitInterest, after: null) {
          nodes {
            interestId
            text
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
      ...MyTeamoTest
    }
  }
  ${MyTravelAtlasFragmentDoc}
  ${MyTeamoTestFragmentDoc}
`
